class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    document
      .querySelectorAll('[id*="cart-icon-bubble"]')
      .forEach((cartLink) => {
        cartLink.setAttribute("role", "button");
        cartLink.setAttribute("aria-haspopup", "dialog");
        cartLink.addEventListener("click", (event) => {
          event.preventDefault();
          this.open(cartLink);
        });
        cartLink.addEventListener("keydown", (event) => {
          if (event.code.toUpperCase() === "SPACE") {
            event.preventDefault();
            this.open(cartLink);
          }
        });
      });
  }

  open(triggeredBy) {
    console.log(1231);
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.style.paddingRight = this.getScrollbarWidth() + "px";
    document.body.classList.add("overflow-hidden");
    // let pathName = window.location.pathname;
    // pathName = pathName.split("/");
    // let messageChangeLanguage = null;
    // let noteChangeLanguage = null;
    // noteChangeLanguage = `Carton réutilisable`;
    // messageChangeLanguage = `Protégez notre planète 🌍! Pour retourner les pièces, souhaitez-vous utiliser un carton réutilisable ?`;
    // if (pathName[1] == "en") {
    //   messageChangeLanguage = `Let's protect our planet 🌍! To reduce waste, would you like to use reusable cardboard?`;
    //   noteChangeLanguage = `Reusable cardboard`;
    // }

    // if (pathName[1] == "de") {
    //   messageChangeLanguage = `Schützen wir unseren Planeten 🌍! Möchten Sie wiederverwendbaren Karton verwenden, um den Abfall zu reduzieren?`;
    //   noteChangeLanguage = `Wiederverwendbarer Karton`;
    // }
    // if (pathName[1] == "it") {
    //   messageChangeLanguage = `Proteggiamo il nostro pianeta 🌍! Per ridurre gli sprechi vuoi utilizzare il cartone riutilizzabile?`;
    //   noteChangeLanguage = `Cartone riutilizzabile`;
    // }
    // document.querySelector('label[for="check-save-world"]').textContent =
    //   messageChangeLanguage;

    // fetch("https://helloasia.ch/cart/update.js", {
    //   method: "POST",
    //   body: JSON.stringify({
    //     note: noteChangeLanguage,
    //   }),
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    // })
    //   .then((response) => response.json())
    //   .then((data) => {
    //     console.log("Cart updated:", data);
    //     // document.querySelector('.chm-toggle').classList.remove('toggle-opening');
    //   });
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
    document.body.style.paddingRight = "";
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      console.log(sectionElement);
      if (sectionElement) {
        sectionElement.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }

      if (
        section.id == "cart-free-delivery" &&
        document.querySelector("#product-page-free-delivery")
      ) {
        document.querySelector("#product-page-free-delivery").innerHTML =
          this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
      }
    });
    console.log(1);
    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    console.log(html);
    console.log(selector);
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
      {
        id: "cart-icon-bubble--mobile",
      },
      {
        id: "cart-free-delivery",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-icon-bubble--mobile",
        section: "cart-icon-bubble--mobile",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
